<nb-card class="modal-full">
    <nb-card-header>Edit text</nb-card-header>
    <nb-card-body>
        <div class="form-group">
            <multilang-editor [model]="_model" editMode="true" [htmlMode]="htmlMode" [languages]="languages" [defaultLang]="defaultLang"></multilang-editor>
        </div>
    </nb-card-body>
    <nb-card-footer>
        <div class="row">
            <button class="cancel" nbButton status="danger" (click)="cancel()">Cancel</button>
            <button nbButton status="success" (click)="save()">Save</button>
        </div>
    </nb-card-footer>
</nb-card>
      